import { Layout } from '@/Layout'
import { Account as AccountComponent } from '@/templates/Account'

export const Account = () => {
  return (
    <Layout title="Account" showBackButton showCreateButton={false}>
      <AccountComponent />
    </Layout>
  )
}
